import type { BrandStack, OnboardingBrand } from "../../types/onboarding";
import { CRM_LABELS, EMAIL_MARKETING_LABELS, FULFILMENT_LABELS, HELPDESK_LABELS, REFUND_PLATFORM_LABELS, SUBSCRIPTION_APP_LABELS } from "./labels";

export const EMPTY_STACK: BrandStack = { crms: [], subscriptionApps: [], helpdesks: [], fulfilment: [], emailMarketing: [], refundsIn: [] };

// Only brands that get steps answer the stack: every brand of a new client, and the brands an existing company
// adds or has nothing connected on yet.
export const findStackBrandIndexes = (brands: OnboardingBrand[]): number[] => brands.flatMap((b, i) => (b.isNew ? [i] : []));

export const listNotSure = (stack: BrandStack, representment: boolean): string[] =>
  Object.entries({
    CRM: stack.crms, "subscription app": stack.subscriptionApps, refunds: stack.refundsIn,
    ...(representment ? { helpdesk: stack.helpdesks, fulfilment: stack.fulfilment, "email marketing": stack.emailMarketing } : {}),
  }).flatMap(([field, list]) => (list?.includes("not_sure") ? [field] : []));

const toNames = <T extends string>(list: T[] | undefined, labels: Record<T, string>, otherName: string | undefined, field: string) =>
  (list ?? []).filter((v) => v !== "none").map((v) => (v === "not_sure" ? `${field} not sure` : v === "other" ? otherName?.trim() || labels[v] : labels[v]));

// "Shopify · Loop · Zendesk · refunds in Shopify"; empty when nothing is picked.
export function toStackSummary(stack: BrandStack, representment: boolean): string {
  const apps = toNames(stack.subscriptionApps, SUBSCRIPTION_APP_LABELS, stack.otherSubscriptionAppName, "subscription app")
    .map((name) => (name === SUBSCRIPTION_APP_LABELS.checkoutchamp ? "CheckoutChamp app" : name));
  const refunds = toNames(stack.refundsIn, REFUND_PLATFORM_LABELS, stack.refundsOtherName, "refunds");
  return [
    ...toNames(stack.crms, CRM_LABELS, stack.otherCrmName, "CRM"),
    ...apps,
    ...(representment ? [
      ...toNames(stack.helpdesks, HELPDESK_LABELS, stack.otherHelpdeskName, "helpdesk"),
      ...toNames(stack.fulfilment, FULFILMENT_LABELS, stack.otherFulfilmentName, "fulfilment"),
      ...(stack.emailMarketing?.includes("none") ? ["no email marketing"] : toNames(stack.emailMarketing, EMAIL_MARKETING_LABELS, stack.otherEmailMarketingName, "email marketing")),
    ] : []),
    ...(stack.refundsIn.includes("not_sure") || !refunds.length ? refunds : [`refunds in ${refunds.join(", ")}`]),
  ].join(" · ");
}
